import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {push} from 'react-router-redux'
import {Row, Col, PageHeader} from 'react-bootstrap'
import extract from '../../core/extract'
import Icon from '../../core/components/Icon'
import {USAGES} from '../models'
import i18n from '../i18n'
import LotCard from './LotCard'
import style from './LotStream.less'

const NO_BUILDING_ID = 'NoBuilding'

function buildingSorter(a, b) {
    if (a.label < b.label) return -1
    if (a.label > b.label) return 1
    return 0
}

function lotSorter(a, b) {
    if (a.usage == b.usage) {
        if (a.ref < b.ref) return -1
        if (a.ref > b.ref) return 1
        return 0
    }

    const aUsage = extract(i18n.usageEnum, a.usage)
    const bUsage = extract(i18n.usageEnum, b.usage)
    if (aUsage < bUsage) return -1
    if (aUsage > bUsage) return 1
    return 0
}

function lotsWithBuildingFilter(building) {
    return (lot) => {
        return lot.addresses.find((a) => a.building && a.building.uid == building.uid) != null
    }
}

function lotsWithoutBuildingFilter(buildings) {
    return (lot) => {
        return lot.addresses.find((address) => {
            return address.building && buildings.find((b) => b.uid == address.building.uid)
        }) == null
    }
}

function lotsFilter(filter, building) {
    return (lot) => {
        return (filter[lot.usage] || []).indexOf(building && building.uid || NO_BUILDING_ID) < 0
    }
}

function usagesAggregator(result, lot) {
    var item = result.find((i) => i.value == lot.usage)

    if (!item) {
        item = {
            value: lot.usage,
            count: 0
        }
        result.push(item)
    }
    item.count++
    return result
}

function aggregate(lots, buildings, filter) {
    // lots with building
    const aggregations = buildings.sort(buildingSorter).map((building) => {
        const buildingLots = lots.filter(lotsWithBuildingFilter(building)).sort(lotSorter)
        const filteredLots = buildingLots.filter(lotsFilter(filter, building))
        const usages = buildingLots.reduce(usagesAggregator, [])

        return {
            building: building,
            lots: filteredLots,
            usages: usages
        }
    })

    // lots with no building
    const noBuildingLots = lots.filter(lotsWithoutBuildingFilter(buildings)).sort(lotSorter)
    const filteredLots = noBuildingLots.filter(lotsFilter(filter))
    const usages = noBuildingLots.reduce(usagesAggregator, [])
    
    if (noBuildingLots.length > 0) {
        aggregations.splice(0, 0, {
            lots: filteredLots,
            usages: usages
        })
    }

    return aggregations
}

class LotStream extends Component {
    static propTypes = {
    }

    constructor(props) {
        super(props)

        this.state = {
            aggregations: [],
            filter: {}
        }
    }

    componentWillMount() {
        const {lotStream, buildingStream} = this.props
        const {filter} = this.state

        const aggregations = aggregate(lotStream, buildingStream, filter)
        this.setState({aggregations})
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.lotStream != this.props.lotStream
            || nextProps.buildingStream != this.props.buildingStream) {
            const {lotStream, buildingStream} = nextProps
            const {filter} = this.state
            
            const aggregations = aggregate(lotStream, buildingStream, filter)
            this.setState({aggregations})
        }
    }

    _toggleFilter(usage, building) {
        const {lotStream, buildingStream} = this.props
        const {filter} = this.state

        const buildingId = building && building.uid || NO_BUILDING_ID
        const usageFilter = filter[usage] || []
        const index = usageFilter.indexOf(buildingId)

        var nextUsageFilter = [...usageFilter]
        if (index >= 0) {
            nextUsageFilter.splice(index, 1)
        } else {
            nextUsageFilter.push(buildingId)
        }

        var nextFilter = {...filter, [usage]: nextUsageFilter}
        const aggregations = aggregate(lotStream, buildingStream, nextFilter)

        this.setState({
            filter: nextFilter,
            aggregations: aggregations
        })
    }

    _isFiltered(usage, building) {
        const {filter} = this.state

        const buildingId = building && building.uid || NO_BUILDING_ID
        const usageFilter = filter[usage]
        return usageFilter && usageFilter.indexOf(buildingId) >= 0
    }

    _navigateLot(event, lot) {
        const {dispatch} = this.props

        event.preventDefault()

        if (event.ctrlKey || event.metaKey) {
            window.open('/patrimonies/' + lot.patrimony.uid + '/lots/' + lot.uid, '_blank')
        } else {
            dispatch(push('/patrimonies/' + lot.patrimony.uid + '/lots/' + lot.uid))
        }
    }

    _navigateBuilding(event, building) {
        const {dispatch} = this.props

        event.preventDefault()

        if (event.ctrlKey || event.metaKey) {
            window.open('/patrimonies/' + building.patrimony.uid + '/buildings/' + building.uid, '_blank')
        } else {
            dispatch(push('/patrimonies/' + building.patrimony.uid + '/buildings/' + building.uid))
        }
    }

    render() {
    	const {aggregations} = this.state

        return (
        	<div>
        		{aggregations.map((aggrega, index) => (
                    <div key={index}>
                        <PageHeader>
                            <div className={style.header}>
                                <div className={style.headerMain}>
                                    {aggrega.building && (
                                        <a
                                            href=''
                                            onClick={(e) => this._navigateBuilding(e, aggrega.building)}>
                                            <span>Bâtiment {aggrega.building.label}</span>
                                        </a>
                                    ) || (<span />)}
                                </div>
                                <div className={style.headerSide}>
                                {aggrega.usages.map((usage, index) => (
                                    <label key={index}>
                                        <input
                                            type='checkbox'
                                            checked={!this._isFiltered(usage.value, aggrega.building)}
                                            onChange={() => this._toggleFilter(usage.value, aggrega.building)} />
                                        <span>
                                            <Icon
                                                icon={usage.value}
                                                size='sm'
                                                count={usage.count} />
                                        </span>
                                    </label>
                                ))}
                                </div>
                            </div>
                        </PageHeader>
                        <Row>
                            {aggrega.lots.map((lot) => (
                                <Col
                                    key={lot.uid}
                                    sm={4}>
                                    <LotCard
                                        lot={lot}
                                        onClick={(e) => this._navigateLot(e, lot)} />
                                </Col>
                            ))}
                        </Row>
                    </div>
                ))}
        	</div>
        )
    }
}

LotStream = connect((state) => ({
    lotStream: state.patrimony.lot.stream,
    buildingStream: state.patrimony.building.stream
}))(LotStream)

export default LotStream


// WEBPACK FOOTER //
// ./lib/patrimony/components/LotStream.js